<script setup>
import { computed, provide, ref } from 'vue';
import { ApplicationWrapper, useCoachQStore, LocationsContextSelect, useRootStore } from '@qsrsoft/myq-core';
import { storeToRefs } from 'pinia';
import useRoutes from '@/views/routes';
import SecurityToolsSnackbar from '@/components/SecurityToolsSnackbar.vue';

const routes = useRoutes();

const coachQStore = useCoachQStore();

provide('coachq', {
  registerGrid: coachQStore.registerGrid,
  unregisterGrid: coachQStore.unregisterGrid,
  setFilterSelections: coachQStore.setFilterSelections,
});

const component = ref();
const singleLocation = computed(() => component?.value?.singleLocation);
const coldScopes = computed(() => component?.value?.coldScopes);
const disableLocationSelector = computed(
  () => component?.value?.disableLocationSelector
);
const hidePageHeader = computed(() => component?.value?.hidePageHeader);
const hideSideBar = computed(() => component?.value?.hideSideBar);
const hideTopBar = computed(() => component?.value?.hideTopBar);
const onlyActiveLocations = computed(
  () => component?.value?.onlyActiveLocations || false
);

const root = useRootStore();
const { countryCode } = storeToRefs(root);
const isAfrica = computed(() => countryCode.value === 'za');
</script>

<template>
  <SecurityToolsSnackbar />
  <ApplicationWrapper
    :routes="routes"
    :hidePageHeader="hidePageHeader"
    :hideSideBar="hideSideBar"
    :hideTopBar="hideTopBar"
    enableCoachQ
    coachQAppName="Reports"
    :hideAlerts="isAfrica"
    :hideChat="isAfrica"
    :hideCoachQ="isAfrica"
  >
    <template v-slot:top-nav v-if="!disableLocationSelector">
      <LocationsContextSelect
        :eager="false"
        :singleSelect="singleLocation"
        :onlyActiveLocations="onlyActiveLocations"
        enableHierarchy
        class="pa-2"
      />
    </template>
    <router-view v-slot="{ Component }">
      <component :is="Component" ref="component" />
    </router-view>
  </ApplicationWrapper>
</template>
